import { NextImage, TextInput } from '@apeiron/temp'
import { Box, InputBaseProps, styled } from '@mui/material'
import EthereumSVG from '@public/icons/icon-ethereum.svg'
import { ChangeEvent, FC } from 'react'

const SectionContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const PriceInputContainer = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`

const SecondaryText = styled(Box)`
  color: #ffffff;
  font-size: 16px;
  line-height: 20px;
`

const PriceIcon = styled(NextImage)`
  width: 20px;
  height: 20px;
`

const PriceInput = styled(TextInput)`
  height: 34px;
  width: 150px;
  margin-left: 10px;

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  & {
    background-color: #0b0b0c;
  }

  & .MuiOutlinedInput-input {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
  }

  ${props => props.theme.breakpoints.down('res1024')} {
    &.MuiOutlinedInput-root,
    &.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
      border-radius: 5px;
    }
  }
`

const TradeSellPriceInputView: FC<Props> = (props: Props) => {
  const {
    autoFocus = false,
    className,
    disabled,
    label,
    showIcon = true,
    onInputChange,
    ...rest
  } = props

  return (
    <SectionContainer className={className}>
      <SecondaryText>{label}</SecondaryText>
      <PriceInputContainer>
        {showIcon && <PriceIcon src={EthereumSVG} />}
        <PriceInput
          {...rest}
          autoFocus={autoFocus}
          readOnly={disabled}
          onChange={onInputChange}
        />
      </PriceInputContainer>
    </SectionContainer>
  )
}

type Props = InputBaseProps & {
  disabled?: boolean
  label: string
  showIcon?: boolean
  onInputChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

export default TradeSellPriceInputView
